module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABRAgMAAAA4I8mbAAAACVBMVEX///+FhYWAgICko1U2AAAAAXRSTlMAQObYZgAAACdJREFUOE9jWIUFMDQwYACmUcFRwVFBnIKj+WhUcFSQcsGpoRggDAA5C0kS2yLjkQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/tree.png
// module id = 224
// module chunks = 0